// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/banner-rectangle-stadium.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-hub {
    margin: 0;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: var(--space-and-half);
    padding-top: var(--space-and-half);
}

.tournament-hub__left-container {
    grid-column-start: 1;
    grid-column-end: 4;
    padding-left: var(--space-and-half);
}

.tournament-hub__center-container {
    grid-column-start: 4;
    grid-column-end: 13;
    /* margin-right: var(--space); */
    margin: 0 50px 0 26px;
     
}
.tournament-hub__center-container-title.baloa-headline-2{
    color: var(--primary-very-dark-color);
    padding-bottom: 49px;
}

.tournament-hub__center-container-create_tournament{
    padding: var(--space-x2);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: var(--space-half);
    margin-bottom: var(--space-and-half);
}

.tournament-hub__center-container-create_tournament_icon{
    font-size: var(--space-x3);
    margin-right: var(--space-and-half);
}

.tournament-hub__center-container-create_tournament_icon.icon-trophy{
    color: var(--primary-dark-color);
}

.tournament-hub__center-container-create_tournament_information{
    display: flex;
    flex-direction: row;
    align-items: center;
}


.tournament-hub__search-tournament {
    display: flex;
    /* align-items: center; */
    /* margin-left: var(--space); */
}

.tournament-hub__search-tournament input:focus {
    outline: none;
}

.tournament-hub__search-tournament .input-search-with-button__input {
    width: 420px;
}

.tournament-hub__search_input {
    min-width: calc(var(--space-x3) * 8);
    border: none;
    min-height: var( --space-x3 );
    border-radius: calc( var( --space-and-half ) - var( --space-eighth ) );
    background: var( --new-gray-background-color );
    padding-left: var( --space-x3 );    
}

.tournament-hub__banner-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-hub__center-container-create_tournament .baloa-headline-1 {
    color: var(--white-color);
}

.tournament-hub__center-container-create_tournament .baloa-subtitle-1 {
    color: var(--white-color);
    margin: var(--space-x2) 0;
}

.tournament-hub__center-container__empty-section {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-bottom: 144px;
}

.tournament-hub__center-container__empty-section .baloa-subtitle-2 {
    color: var(--primary-dark-color);
    margin: var(--space-x2) 0;
}

.tournament-hub__center-container__empty-section img {
    width: 20%;
}

.tournament-hub__center-container__empty-section.invitations img {
    margin-top: calc( var(--space-x3) + var(--space-x3) );
}

.tournament-hub__center-container__empty-section.inscriptions .button {
    display: flex;
    align-items: center;
}

.tournament-hub__center-container__empty-section.inscriptions .hubicon-explore {
    margin-right: var(--space-half-quarter);
}

.tournament-hub__mobile__filter-search {
    display: flex;
    justify-content: center;
    background-color: white;
    padding: calc( var(--space-half) + 2px) var(--space);
}

.tournament-hub__mobile__filter-search .tournament-hub__search-tournament,
.tournament-hub__mobile__filter-search .tournament-hub__search-tournament .tournament-hub__search_input {
    width: 100%;
}

.tournament-hub__mobile__filter-search .tournament-hub__search-tournament .tournament-hub__search_input {
    border-radius: var(--space-half);
}

.tournament-hub__search-tournament .icon-x{
    font-size: calc( var( --space ) + var( --space-quarter ) );
    color: #949F9A;
    margin-left: -40px;
}

.tournament-hub__search-tournament .icon-x:hover{
    cursor: pointer;
}

.tournament-hub__center-container .league-match-report__header {
    margin: var( --space-quarter ) 0 calc( var( --space-and-half ) + var( --space-quarter ) ) 0;
}

.tournament-hub__baloa-landing {
    background-color: #EAF7F0;    
    gap: 8px;
    text-transform: unset;
}

.tournament-hub__header-actions {
    display: flex;
    gap: 8px;
}

.tournament-hub__header-actions .button {
    padding: 12px;
    font-size: 19px;
    line-height: 15px;
}

.skeleton-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
}

.skeleton-container__element {
    border-radius: 8px;
    background: var(--white-color);
    box-shadow: 0px 3.288px 3.288px 0px rgba(170, 193, 182, 0.32);
}

.skeleton-container__element__image-line {
    display: flex;
    align-items: center;
    padding: 10px 8px 8px 8px;
    gap: 8px;
}

.skeleton-container__element__text-lines {
    padding: 8px 8px 10px 8px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .tournament-hub {
        display: block;
        /* top: 40px; */
        position: relative;
        padding-top: 0;
    }
    .tournament-hub__center-container{
        margin: 0;
        padding-top: 5px;
    }
    .tournament-hub__center-container-create_tournament{
        display: block;
        /* padding: 4px 0 21px 8px;
        margin: 0 12px; */
        border-radius: 0%;
        padding: 16px;
    }
    .tournament-hub__center-container-title.baloa-headline-2 {
        display:none;
    }

    .tournament-hub__center-container-create_tournament_icon.icon-trophy {
        font-size: 20px;
        margin:8px;
    }

    .tournament-hub__center-container-create_tournament_information{
        padding-bottom: 8px;
    }
    
    .tournament-hub__center-container-create_tournament_information p{ 
        color: var(--basic-gray-color);
    }

    .tournament-hub__center-container-create_tournament .baloa-subtitle-1 {
        margin: 16px 0 0 0;
    }

    .tournament-hub__mobile__filter-search {
        background-color: unset;
        padding: 12px 0;
        width: 100%;
        justify-content: space-between;
        flex-direction: column;
        gap: 16px;
    }

    .tournament-hub__mobile__filter-search__btns-action {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .tournament-hub__mobile__filter-search__btns-action .button {
        width: 50%;
        padding: 8px;
    }
    
    .tournament-hub__mobile__filter-search .tournament-hub__search-tournament {
        width: 100%;        
        margin-right: 8px;
    }

    .tournament-hub__search-tournament .tournament-hub__search_input {
        min-width: unset;
    }

    .tournament-hub__search-tournament__button.button.small {
        padding: 10px;
    }

    .tournament-hub__center-container-create_tournament{
        margin-bottom: 0;
    }

    .tournament-hub__tabs {
        background: var(--white-color);
    }

    .tournament-hub__tabs .MuiTab-wrapper {
        text-transform: none;
        font-family: var(--secondary-font);
        font-style: normal;
        font-weight: var(--font-regular);
        font-size: var(--space);
        line-height: calc(var(--space) + var(--space-eighth) + 1px);
        letter-spacing: 0.0025em;
        color: var(--basic-gray-color );
    }

    .tournament-hub__tabs.MuiTabs-root {
        border-top: none;
        /* min-height: 28px; */
        padding-top: 23px;
    }

    .tournament-hub__tabs .MuiTabs-flexContainer {
        display: block;
        border-bottom: 0;
    }
    
    .tournament-hub__tabs .MuiTabs-indicator {
        bottom: auto;
        width: 63px;
        height: 4px;
        border-radius: 4px 4px 0px 0px;
    }

    .tournament-hub__tabs .MuiTab-fullWidth {
        white-space: nowrap;
        padding: var(--space-quarter) 0;
        min-height: 0;
        font-family: var(--secondary-font);
        margin: 0 12px;
    }

    .skeleton-container__element {
        padding: 8px;
        box-shadow: 0px 4px 4px 0px #EDEFEE;
        display: flex;
        gap: 8px;
    }
    .skeleton-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px 8px;
    }

    .skeleton-container__element__group {
        width: calc(100% - 128px);
    }

    .skeleton-container__element__image-line {
        padding: 0;
        gap: 4px;
    }

    .skeleton-container__element__text-lines {
        padding: 4px 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/views/TournamentHubView.styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,aAAa;IACb,sCAAsC;IACtC,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;IAChC,qBAAqB;;AAEzB;AACA;IACI,qCAAqC;IACrC,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,yDAA4E;IAC5E,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,6BAA6B;IAC7B,sEAAsE;IACtE,8CAA8C;IAC9C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,oDAAoD;AACxD;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,0DAA0D;IAC1D,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,yBAAyB;IACzB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,6DAA6D;AACjE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,cAAc;QACd;yBACiB;QACjB,iBAAiB;QACjB,aAAa;IACjB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,WAAW;QACX,8BAA8B;QAC9B,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;QACpB,kCAAkC;QAClC,kBAAkB;QAClB,gCAAgC;QAChC,uBAAuB;QACvB,2DAA2D;QAC3D,wBAAwB;QACxB,+BAA+B;IACnC;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,+BAA+B;QAC/B,aAAa;QACb,kCAAkC;QAClC,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,mCAAmC;QACnC,aAAa;QACb,QAAQ;IACZ;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".tournament-hub {\n    margin: 0;\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--space-and-half);\n    padding-top: var(--space-and-half);\n}\n\n.tournament-hub__left-container {\n    grid-column-start: 1;\n    grid-column-end: 4;\n    padding-left: var(--space-and-half);\n}\n\n.tournament-hub__center-container {\n    grid-column-start: 4;\n    grid-column-end: 13;\n    /* margin-right: var(--space); */\n    margin: 0 50px 0 26px;\n     \n}\n.tournament-hub__center-container-title.baloa-headline-2{\n    color: var(--primary-very-dark-color);\n    padding-bottom: 49px;\n}\n\n.tournament-hub__center-container-create_tournament{\n    padding: var(--space-x2);\n    background-image: url(\"../../../assets/images/banner-rectangle-stadium.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    border-radius: var(--space-half);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-hub__center-container-create_tournament_icon{\n    font-size: var(--space-x3);\n    margin-right: var(--space-and-half);\n}\n\n.tournament-hub__center-container-create_tournament_icon.icon-trophy{\n    color: var(--primary-dark-color);\n}\n\n.tournament-hub__center-container-create_tournament_information{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n\n.tournament-hub__search-tournament {\n    display: flex;\n    /* align-items: center; */\n    /* margin-left: var(--space); */\n}\n\n.tournament-hub__search-tournament input:focus {\n    outline: none;\n}\n\n.tournament-hub__search-tournament .input-search-with-button__input {\n    width: 420px;\n}\n\n.tournament-hub__search_input {\n    min-width: calc(var(--space-x3) * 8);\n    border: none;\n    min-height: var( --space-x3 );\n    border-radius: calc( var( --space-and-half ) - var( --space-eighth ) );\n    background: var( --new-gray-background-color );\n    padding-left: var( --space-x3 );    \n}\n\n.tournament-hub__banner-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-hub__center-container-create_tournament .baloa-headline-1 {\n    color: var(--white-color);\n}\n\n.tournament-hub__center-container-create_tournament .baloa-subtitle-1 {\n    color: var(--white-color);\n    margin: var(--space-x2) 0;\n}\n\n.tournament-hub__center-container__empty-section {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    padding-bottom: 144px;\n}\n\n.tournament-hub__center-container__empty-section .baloa-subtitle-2 {\n    color: var(--primary-dark-color);\n    margin: var(--space-x2) 0;\n}\n\n.tournament-hub__center-container__empty-section img {\n    width: 20%;\n}\n\n.tournament-hub__center-container__empty-section.invitations img {\n    margin-top: calc( var(--space-x3) + var(--space-x3) );\n}\n\n.tournament-hub__center-container__empty-section.inscriptions .button {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-hub__center-container__empty-section.inscriptions .hubicon-explore {\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-hub__mobile__filter-search {\n    display: flex;\n    justify-content: center;\n    background-color: white;\n    padding: calc( var(--space-half) + 2px) var(--space);\n}\n\n.tournament-hub__mobile__filter-search .tournament-hub__search-tournament,\n.tournament-hub__mobile__filter-search .tournament-hub__search-tournament .tournament-hub__search_input {\n    width: 100%;\n}\n\n.tournament-hub__mobile__filter-search .tournament-hub__search-tournament .tournament-hub__search_input {\n    border-radius: var(--space-half);\n}\n\n.tournament-hub__search-tournament .icon-x{\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n    color: #949F9A;\n    margin-left: -40px;\n}\n\n.tournament-hub__search-tournament .icon-x:hover{\n    cursor: pointer;\n}\n\n.tournament-hub__center-container .league-match-report__header {\n    margin: var( --space-quarter ) 0 calc( var( --space-and-half ) + var( --space-quarter ) ) 0;\n}\n\n.tournament-hub__baloa-landing {\n    background-color: #EAF7F0;    \n    gap: 8px;\n    text-transform: unset;\n}\n\n.tournament-hub__header-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.tournament-hub__header-actions .button {\n    padding: 12px;\n    font-size: 19px;\n    line-height: 15px;\n}\n\n.skeleton-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 20px;\n}\n\n.skeleton-container__element {\n    border-radius: 8px;\n    background: var(--white-color);\n    box-shadow: 0px 3.288px 3.288px 0px rgba(170, 193, 182, 0.32);\n}\n\n.skeleton-container__element__image-line {\n    display: flex;\n    align-items: center;\n    padding: 10px 8px 8px 8px;\n    gap: 8px;\n}\n\n.skeleton-container__element__text-lines {\n    padding: 8px 8px 10px 8px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .tournament-hub {\n        display: block;\n        /* top: 40px; */\n        position: relative;\n        padding-top: 0;\n    }\n    .tournament-hub__center-container{\n        margin: 0;\n        padding-top: 5px;\n    }\n    .tournament-hub__center-container-create_tournament{\n        display: block;\n        /* padding: 4px 0 21px 8px;\n        margin: 0 12px; */\n        border-radius: 0%;\n        padding: 16px;\n    }\n    .tournament-hub__center-container-title.baloa-headline-2 {\n        display:none;\n    }\n\n    .tournament-hub__center-container-create_tournament_icon.icon-trophy {\n        font-size: 20px;\n        margin:8px;\n    }\n\n    .tournament-hub__center-container-create_tournament_information{\n        padding-bottom: 8px;\n    }\n    \n    .tournament-hub__center-container-create_tournament_information p{ \n        color: var(--basic-gray-color);\n    }\n\n    .tournament-hub__center-container-create_tournament .baloa-subtitle-1 {\n        margin: 16px 0 0 0;\n    }\n\n    .tournament-hub__mobile__filter-search {\n        background-color: unset;\n        padding: 12px 0;\n        width: 100%;\n        justify-content: space-between;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .tournament-hub__mobile__filter-search__btns-action {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n    }\n\n    .tournament-hub__mobile__filter-search__btns-action .button {\n        width: 50%;\n        padding: 8px;\n    }\n    \n    .tournament-hub__mobile__filter-search .tournament-hub__search-tournament {\n        width: 100%;        \n        margin-right: 8px;\n    }\n\n    .tournament-hub__search-tournament .tournament-hub__search_input {\n        min-width: unset;\n    }\n\n    .tournament-hub__search-tournament__button.button.small {\n        padding: 10px;\n    }\n\n    .tournament-hub__center-container-create_tournament{\n        margin-bottom: 0;\n    }\n\n    .tournament-hub__tabs {\n        background: var(--white-color);\n    }\n\n    .tournament-hub__tabs .MuiTab-wrapper {\n        text-transform: none;\n        font-family: var(--secondary-font);\n        font-style: normal;\n        font-weight: var(--font-regular);\n        font-size: var(--space);\n        line-height: calc(var(--space) + var(--space-eighth) + 1px);\n        letter-spacing: 0.0025em;\n        color: var(--basic-gray-color );\n    }\n\n    .tournament-hub__tabs.MuiTabs-root {\n        border-top: none;\n        /* min-height: 28px; */\n        padding-top: 23px;\n    }\n\n    .tournament-hub__tabs .MuiTabs-flexContainer {\n        display: block;\n        border-bottom: 0;\n    }\n    \n    .tournament-hub__tabs .MuiTabs-indicator {\n        bottom: auto;\n        width: 63px;\n        height: 4px;\n        border-radius: 4px 4px 0px 0px;\n    }\n\n    .tournament-hub__tabs .MuiTab-fullWidth {\n        white-space: nowrap;\n        padding: var(--space-quarter) 0;\n        min-height: 0;\n        font-family: var(--secondary-font);\n        margin: 0 12px;\n    }\n\n    .skeleton-container__element {\n        padding: 8px;\n        box-shadow: 0px 4px 4px 0px #EDEFEE;\n        display: flex;\n        gap: 8px;\n    }\n    .skeleton-container {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        padding: 12px 8px;\n    }\n\n    .skeleton-container__element__group {\n        width: calc(100% - 128px);\n    }\n\n    .skeleton-container__element__image-line {\n        padding: 0;\n        gap: 4px;\n    }\n\n    .skeleton-container__element__text-lines {\n        padding: 4px 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
